export const BRANDS = [
  {
    id: "pb-travel-angel",
    number: "01",
    name: "PB Travel Angel",
    url: "https://pbtravelangel.com",
    domain: "pbtravelangel.com",
    accent: "#B57F73",
    short:
      "Boutique luxury travel advisory. Bespoke trip planning and curated destination kits for travellers who want someone watching over the details.",
    long: "PB Travel Angel is a boutique luxury travel advisory. Every itinerary is planned by hand — the flights, the rooms, the tables, the small things that make a trip feel considered rather than booked. Clients also receive curated destination kits before they leave, so the reading, the packing and the practicalities are done for them. It is for travellers who value their time and want a person, not a platform, watching over the details.",
  },
  {
    id: "cloud-my-luxury",
    number: "02",
    name: "Cloud My Luxury",
    url: "https://cloudmyluxury.com",
    domain: "cloudmyluxury.com",
    accent: "#6B7F8C",
    short:
      "Travel intelligence. Honest assessments of luxury properties and experiences — what they cost, what you actually get, and what the brochure leaves out.",
    long: "Cloud My Luxury is travel intelligence for people who read past the photography. It publishes honest assessments of luxury properties and experiences — what they cost, what you actually get, and what the brochure leaves out. No sponsored rankings, no paid placement. It is for travellers who are happy to spend money well and unwilling to spend it blind.",
  },
  {
    id: "the-expat-studio",
    number: "03",
    name: "The Expat Studio",
    url: "https://theexpatstudio.com",
    domain: "theexpatstudio.com",
    accent: "#7E8F7A",
    short:
      "For people building a life abroad. Country guides and relocation resources that tell you the real cost, the real timeline and the real paperwork.",
    long: "The Expat Studio is for people building a life abroad. Its country guides and relocation resources set out the real cost, the real timeline and the real paperwork — visas, tax, healthcare, banking, the lot — written plainly and kept current. It is for anyone standing at the beginning of a move who wants the truth before the ticket.",
  },
  {
    id: "staycraft-studio",
    number: "04",
    name: "StayCraft Studio",
    url: "https://staycraftstudio.com",
    domain: "staycraftstudio.com",
    accent: "#D1A562",
    short:
      "Short-stay property. Hosting consultancy, listing audits and local experiences for owners who want a property that performs.",
    long: "StayCraft Studio works in short-stay property. It offers hosting consultancy, listing audits and help shaping local experiences, so owners can see exactly why a property underperforms and what to do about it. It is for hosts who treat their place as a craft — and want the bookings, reviews and calm that come from doing it properly.",
  },
  {
    id: "soft-spine-press",
    number: "05",
    name: "Soft Spine Press",
    url: "https://softspinepress.com",
    domain: "softspinepress.com",
    accent: "#8D7685",
    short:
      "An independent digital press. Ebooks and templates, published to be kept.",
    long: "Soft Spine Press is an independent digital press. It publishes ebooks and templates — practical, well-made things for travel, relocation and working for yourself — designed to be kept rather than scrolled past. It is for readers who would rather own one good guide than skim a hundred posts.",
  },
];

export const GROUP_LINE = "Dream it. Plan it. Live it. From Queensland to the world.";
